export class mobileNavigation {
    navToggle: HTMLButtonElement;
    brandToggle: HTMLButtonElement;
    bodyElement: HTMLElement;
    mobileSubnavTriggers: Array<any>;

    nav: HTMLElement;
    constructor(navEl: HTMLElement) {
        this.nav = navEl;
        this.bodyElement = document.querySelector('body') as HTMLElement;
        this.navToggle = this.nav.querySelector('.mobile-nav-toggle') as HTMLButtonElement;
        this.brandToggle = this.nav.querySelector('.brand-select-toggle') as HTMLButtonElement;
        this.mobileSubnavTriggers = [].slice.call(document.getElementsByClassName('mobile-nav-main-child-toggle'));

        this.navToggle.addEventListener('click', this.toggleNav.bind(this));
        this.brandToggle.addEventListener('click', this.toggleBrand.bind(this));

        this.mobileSubnavTriggers.forEach((mobileSubnavTrigger) => {
            mobileSubnavTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                var subnavID = this.getAttribute('data-trigger-id');
                var subnavToOpen = document.querySelector('[data-id="' + subnavID + '"]');
                this.classList.toggle('open');
                subnavToOpen.classList.toggle('open');
                if (subnavToOpen.classList.contains('open')) {
                    subnavToOpen.setAttribute('aria-hidden', 'false');
                }
                else {
                    subnavToOpen.setAttribute('aria-hidden', 'true');
                }
            });
        });
    }
    toggleNav() {
        if (!this.nav.classList.contains('open')) {
            this.nav.classList.add('open');
            this.nav.classList.remove('closed');
            this.bodyElement.classList.add('nav-open');
            //this.bodyElement.addEventListener('touchmove', function(e) {

            //    e.preventDefault();
            //}, false);
            // Close brand selector when nav open
            this.nav.classList.remove('brand-open');
            this.nav.classList.add('brand-closed');
        }
        else {
            this.nav.classList.remove('open');
            this.nav.classList.add('closed');
        }
    }
    toggleBrand() {
        if (!this.nav.classList.contains('brand-open')) {
            this.nav.classList.add('brand-open');
            this.nav.classList.remove('brand-closed');

            //close main nav
            this.nav.classList.remove('open');
            this.nav.classList.add('closed');
        }
        else {
            this.nav.classList.remove('brand-open');
            this.nav.classList.add('brand-closed');
        }

    }
}
